var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 29.1429L50.1708 29.1697C49.5002 27.0732 48.2417 25.2555 46.5708 23.9702C44.8999 22.6849 42.8999 21.9962 40.85 22C35.3901 22 30.95 26.8054 30.95 32.7143L30.9516 32.9393C29.5353 33.3369 28.2809 34.2317 27.3848 35.4835C26.4887 36.7354 26.0017 38.2736 26 39.8571C26 43.7964 28.9601 47 32.6 47H40.85V38.8107L38.7165 41.1196C38.5637 41.286 38.3819 41.4181 38.1817 41.5082C37.9815 41.5983 37.7668 41.6447 37.55 41.6447C37.3332 41.6447 37.1185 41.5983 36.9183 41.5082C36.7181 41.4181 36.5363 41.286 36.3834 41.1196C36.2301 40.954 36.1084 40.7572 36.0254 40.5405C35.9424 40.3239 35.8997 40.0917 35.8997 39.8571C35.8997 39.6226 35.9424 39.3904 36.0254 39.1738C36.1084 38.9571 36.2301 38.7603 36.3834 38.5946L41.3318 33.2393C41.4851 33.073 41.6671 32.9411 41.8676 32.851C42.0681 32.761 42.283 32.7147 42.5 32.7147C42.717 32.7147 42.9319 32.761 43.1324 32.851C43.3329 32.9411 43.5149 33.073 43.6682 33.2393L48.6165 38.5946C48.9259 38.9295 49.0998 39.3836 49.0998 39.8571C49.0998 40.3307 48.9259 40.7848 48.6165 41.1196C48.3072 41.4545 47.8875 41.6426 47.45 41.6426C47.0125 41.6426 46.5928 41.4545 46.2834 41.1196L44.15 38.8107V47H50.75C55.299 47 59 42.9946 59 38.0714C59 33.1482 55.299 29.1429 50.75 29.1429Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8H40L32 0H8C3.6 0 0.04 3.6 0.04 8L0 56C0 60.4 3.6 64 8 64H72C76.4 64 80 60.4 80 56V16C80 11.6 76.4 8 72 8ZM72 56H8V16H72V56Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.56158f2fba0452559e539a62e5a367e3.svg";
export { ForwardRef as ReactComponent };